"use strict";

function ValidationService(labelService) {
	var errors = {} ; 
	
	var supressErrorTypes = [
		'ccNumberType'/** cc validation library used
						 generates two error messages 
						 for invalid card number and invalid
						 card type, the latter is not required
						 to be displayed. */
	];

	function isFormValid() {
		return errors.length > 0;
	}

	function clearAllErrors() {
		errors = {} ; 
	}

	function getFieldErrors(fieldSelector) {
		var err = null ; 
		for (var elementId in errors) {
			var error = errors[elementId] ; 
			if ( error.input == fieldSelector ){
				err = error ; 
				break ; 
			}
		}
		return err;
	}

	/**
	* Error types that are redundant are supressed/filtered out, to avoid displaying them to users. 
	*/
	function removeSupressedErrors(inputErrors) {
		angular.forEach(supressErrorTypes, function(errorType) {
			if ( inputErrors.hasOwnProperty(errorType)) 
				delete inputErrors[errorType] ; 
		});
		return inputErrors ; 
	}

	function registerInputErrors(element, fieldSelector, inputErrors) {
		var commonFieldArray = element.parents('ng-form').map(function(index, parent){return 	$(parent).attr('name');}) ; 
		var commonFieldId =  /** this is meant to be common among multiple radio or checkbox inputs */
			Array.prototype.join.call(commonFieldArray, '_') + element.attr('name') ; 

		var wildcard = element.parents('.ctrl-holder').attr('label-wildcard') ; 
		inputErrors = removeSupressedErrors(inputErrors) ; 

		errors[commonFieldId] = {
			input : fieldSelector, 
			label: labelService.getLabelFor(element.attr('label-key')),
			element: element, 
			wildcard : wildcard,
			errors : inputErrors
		};
	}

	function getAllErrors() {
		return getNonEmptyErrors(errors) ; 
	}

	function getNonEmptyErrors(errors) {
		var nonEmptyErrors = {} ; 
		for (var key in errors) {
			if ( errors[key] && errors[key].errors && Object.keys(errors[key].errors).length > 0 )
				nonEmptyErrors[key] = errors[key] ; 
		}

		return nonEmptyErrors ; 
	}

	/*
	* Validate input fields
	* Param - field name of element
	*/
	function validateField(fieldKey){
		var nonEmptyErrors = {} ; 
		for (var key in errors) {

			if ( errors[key] && errors[key].errors && Object.keys(errors[key].errors).length > 0 && key.indexOf(fieldKey) >= 0 ){
				nonEmptyErrors[key] = errors[key] ; 
				break;
			}
		}

		return nonEmptyErrors ; 
	}

	function validateInput(element, fieldSelector, messageKey) {
		var inputErrors = {} ; 
		if ( ! fieldSelector ) {
			console.error('Empty validation selector for field' );
			return {};
		}

		var $error = fieldSelector.$error ;
		if ( ! $error ) {
			inputErrors = {};
			return inputErrors ; 
		}

		for (var key in $error) {
			inputErrors[key] = labelService.getValidationMessagesFor(messageKey, key) ; 
			//console.log('input errors for ' + key , inputErrors[key]) ;
		}

		registerInputErrors(element, fieldSelector, inputErrors) ; 

		return  inputErrors ;
	}

	return {
		getFieldErrors: getFieldErrors,
		validateInput: validateInput,
		getAllErrors: getAllErrors,
		clearAllErrors: clearAllErrors,
		validateField: validateField
	};
}
